module.exports = __webpack_public_path__ + "static/media/drag-handler.78310cc6.svg";